/**
 @ngdoc service
 @name mapScreeningcaseTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapScreeningcaseTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));
            tileFactory.addFieldToColumn2(tileFactory.field.newLinkField('candidateName','candidateURI'));
            tileFactory.addFieldToColumn3(tileFactory.field.newLinkField('managerName','managerURI'));
            tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('businessName','businessRecordURI'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('requestType'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('requesterName'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('assignedToName'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('primaryStatus'));
            tileFactory.addFieldToColumn1(tileFactory.field.newInactiveField('mobile', 'mobileOptout', 'mobileOptout'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('slaDate'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('dataCollectionReceived'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('email'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('slaStatus'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('startDate'));
            
            tileFactory.tileData.adverseResponse = rawTileData.adverseResponse
            tileFactory.tileData.adverseResponseMultiple = rawTileData.adverseResponseMultiple

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapScreeningcaseTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapScreeningcaseTileService', mapScreeningcaseTileService);
}());